// import Layout from '@/views/Layout';
import sysManage from './sysManage';
import advertiserManage from './advertiserManage';
import dataReport from './dataReport';
// import channelReport from './channelReport';
import aggregationManage from './aggregationManage';
import operationManage from './operationManage';
// import productReport from './productReport';
import agentReport from './agentReport';
// import toolsManage from './toolsManage';

/**
 * 聚合menuRoutes, 也会用来做 menuRoutes 权限管理
 * 提示：由于route结构作menu管理，所以单一一级菜单导航暂不支持!!；
 * */

const menuRoutes = [
  sysManage,
  advertiserManage,
  aggregationManage,
  // channelReport,
  dataReport,
  // productReport,
  operationManage,
  agentReport,
  // toolsManage,
];

export default menuRoutes;

/**
 *  过滤菜单路由
 *
 * @export
 * @param {Array} [routes=menuRoutes]
 * @param {Array} [perm=[]] [optional]
 * @returns
 */
export function filterMenuRoute(perm = [], routes = menuRoutes) {
  const iRoutes = JSON.parse(JSON.stringify(routes));
  // perm = perm.concat('DirectSaleReportDataView');
  // perm = perm.concat('DirectSaleReportDetail');
  const isMenu = (route) => !!(route.meta || {}).isMenu;
  const isPerm = (route) => perm.join(',').indexOf(route.name) > -1;

  return iRoutes.filter((route) => {
    let flag = isMenu(route);

    // 校验权限
    if (flag && perm.length > 0) {
      flag = isPerm(route);
    }

    // 校验子路由
    if (flag && (route.children || []).length > 0) {
      route.children = filterMenuRoute(perm, route.children);
    }

    return flag;
  });
}
